import { Typography } from "@mui/material";
import Box from "@mui/material/Box";

/**
 * Subheading component renders a styled subheading.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.text - The text content of the subheading.
 * @param {object} [props.sx] - Custom styling overrides using MUI's sx prop.
 * @returns {JSX.Element} The Subheading component with styled Typography element.
 */
function Subheading({ text, sx }) {
  return (
    <Box>
      <Typography
        variant="h3"
        sx={{
          fontSize: "1.4rem",
          fontWeight: "bold",
          fontStyle: "italic",
          ...sx,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}

export default Subheading;
